import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

const DOCKING_HEIGHT_WITH_RIBBON = 120;
const DOCKING_HEIGHT_WITHOUT_RIBBON = 72;

export default function getBottomDockingHeight(formId: string) {
    const fullComposeViewState = getFullComposeViewState(formId);
    return fullComposeViewState.isRibbonShown
        ? DOCKING_HEIGHT_WITH_RIBBON
        : DOCKING_HEIGHT_WITHOUT_RIBBON;
}
